import { render, staticRenderFns } from "./_OrderProduct.vue?vue&type=template&id=5dad75d0&scoped=true&"
import script from "./_OrderProduct.vue?vue&type=script&lang=js&"
export * from "./_OrderProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dad75d0",
  null
  
)

export default component.exports